import { ICombineEngine, ICombine, DetailPrice } from '@app/shared';
import { find, minBy, values, has, map, filter } from 'lodash';
import { Line } from './line.model';
import { Room } from './room.model';

export type RoomsRecommended = {
    [key: string]: number;
} | null;

export type Recommandations = { alias: string, rooms: RoomsRecommended };
export type ItemRecommandation = { room: Room, line: Line, qte: number, bedding: any, keybedSelected: string, valbed: Array<any>, adults: number, child: number };
export type BestRecommandation = { price: number, roomsRecommended: Recommandations, items: Array<ItemRecommandation> } | null;


export class Ota {
    rooms_recommended: RoomsRecommended;
    bestprice: {};
    bestPrices: {
        bestprice: null | ICombine,
        partner: null | ICombine,
        googleHotelAds: null | ICombine,
    };
    engine: {};
    engineNotMap: {};
    enginesearch: string;
    uid: Array<string>;
    s: string;
    localisation: string;
    iqstock: number;
    ds: string;
    de: string;
    //    stopsell: Array<string>;
    otaEnvEtab: number;
    env: string;
    urlcapture: string;
    url: string;

    constructor(data, alias: string) {
        //        if (data) {
        this.rooms_recommended = data.rooms_recommended || null;
        this.bestprice = data.bestprice;
        //this.createIndex(data.engine);
        this.engine = this.addAliasCombine(data.engine, alias);
        this.bestprice = data.bestprice;
        this.bestPrices = data.bestPrices;
        this.enginesearch = data.enginesearch;
        this.uid = data.uid;
        this.s = data.s;
        this.localisation = data.localisation;
        this.iqstock = data.iqstock;
        this.ds = data.ds;
        this.de = data.de;
        this.otaEnvEtab = data.otaEnvEtab;
        this.env = data.env;
        this.urlcapture = data.urlcapture;
        this.url = data.url;
        this.engineNotMap = data.engine_not_map;
        //        }
    }

    /**
     * @param idRoom id room
     * @returns {}
     */
    getLineByRoom(idRoom) {
        return find(this.engine, { mapchambre: idRoom });
    }

    /**
    * get min combine ( except  offre partner & googleHotelAds ) by ttc
    * @returns ICombine
    */
    public getMinEngine(): ICombine {
        return !!this.bestPrices && !!this.bestPrices.bestprice ? this.bestPrices.bestprice : null;
        // return minBy(values(filter(this.engine, { 'is_partner': false, 'isGoogleHotelAds': false })), 'ttc');
        //return minBy(values(this.engine), 'ttc');
    }
    public getMinEngineWithoutRoom(skipRoomId: number): ICombine {
        return minBy(values(filter(this.engine, (e: any) => !e.is_partner && !e.isGoogleHotelAds && parseInt(e.code_room) != skipRoomId
        )), 'ttc');
    }

    /**
    * get min combine Google Hotel Ads by ttc
    * @returns ICombine
    */
    public getMinEngineGoogleCache(): ICombine | null {
        return !!this.bestPrices && !!this.bestPrices.googleHotelAds ? this.bestPrices.googleHotelAds : null;
        // return minBy(values(filter(this.engine, { 'isGoogleHotelAds': true })), 'ttc');
    }

    /**
    * get combine Partner by ttc
    * @returns ICombine
    */
    public getEnginePartner(): ICombine | null {
        return !!this.bestPrices && !!this.bestPrices.partner ? this.bestPrices.partner : null;
        // return minBy(values(filter(this.engine, { 'is_partner': true })), 'ttc');
    }

    /**
     * add engine with push
     */
    public addEnginWithPush(key, value) {
        if (!has(this.engine, key))
            this.engine[key] = value;
    }

    private addAliasCombine(engine: any, alias: string): object {
        let engines: {} = {};
        map(engine, (v: ICombine, k) => {
            engines[k] = v;
            engines[k]['alias'] = alias; // by reference
        })
        return engines;
    }

    /**
     * add index "engineKey" in engine
     */
    // private createIndex(engines):void {
    //     map(engines, (v,k) => {
    //         v['engineKey'] = v.indexSearch;
    //     })
    // }
}

export class BestPrice implements ICombineEngine {
    loading: boolean;
    name: string;
    alias: string;
    combine: ICombine;

    constructor(name: string, alias: string, loading: boolean = true, combine: ICombine = null) {
        this.name = name;
        this.alias = alias;
        this.loading = loading;
        this.combine = combine;
    }

    /**
     * get price 
     * @param hasPromo price with/out promo 
     * @returns {}
     */
    getPrice(hasPromo: boolean): DetailPrice {
        if (!this.combine) {
            return null;
        }
        if (hasPromo) {
            return this.combine.detailPrice
        }
        return this.combine.detailPrice_without_promo
    }
}